/**
 * External dependencies
 */
import { find } from "lodash";

/**
 * Internal dependencies
 */
import { getEditedLayout } from "state/dashboard-layouts/selectors";
import removeItemFromLayout from "./remove-item-from-layout";

export default (layoutId, widgetId) => (dispatch, getState) => {
  const layout = getEditedLayout(getState(), layoutId);

  if (!layout) {
    return;
  }

  const item = find(layout.items, { widgetId: widgetId });

  item && dispatch(removeItemFromLayout(layout.id, item.id));
};
